/**
 * Worker sessions repository (ADR-0009 Phase 2).
 */

import {
  loadAllWorkerSessionsForBusiness,
  loadSessionsFromKey,
  persistWorkerSessions,
  workerSessionStorageKey
} from '../../utils/workerSessionsStorage';

export class KvSessionsRepository {
  listAllForBusiness(businessId) {
    return loadAllWorkerSessionsForBusiness(businessId);
  }

  listForWorker(businessId, workerId) {
    return loadSessionsFromKey(workerSessionStorageKey(businessId, workerId));
  }

  persistForWorker(businessId, workerId, sessions) {
    return persistWorkerSessions(businessId, workerId, sessions);
  }
}
